import { useContext, useMemo } from 'react'

import { isArray, isFunction } from 'lodash'

import { InstitutionContext } from '../../../../Providers/InstitutionProvider'
import { SchoolContext } from '../../../../Providers/SchoolProvider'
import { isObject } from '../../../../utils'
import EntitiesSelector from '../EntitiesSelector'
import { SchoolModalContext } from '../../../../Providers/Forms/SchoolModal'

const SchoolsSelector = ({ className = '', empty = false, disabled, schools = null, multiple = 'default', reverse = false, style = {}, values, dropdownRender, onChange }) => {
  const ic = useContext(InstitutionContext)
  const sc = useContext(SchoolContext)
  const modalContext = useContext(SchoolModalContext)

  const schoolEntities = useMemo(() => {
    let schoolEntities = []

    if (isArray(schools)) {
      schoolEntities = schools
    } else if (isObject(ic)) {
      schoolEntities = ic.schools
    } else if (isObject(sc)) {
      schoolEntities = [sc.school]
    }

    return schoolEntities
  }, [schools, ic, sc])

  const schoolsOptions = useMemo(() => schoolEntities.map(school => {
    const props = {
      value: school.id,
      entity: school
    }

    if (reverse) {
      props.label = school.name
      props.tooltip = school.abbreviation ?? ''
    } else {
      props.label = school.abbreviation ?? school.name
      props.tooltip = school.name
    }

    return props
  }), [schoolEntities, reverse])

  return (
    <EntitiesSelector
      className={className}
      disabled={disabled}
      entityOptions={schoolsOptions}
      multiple={multiple}
      showSearch
      style={style}
      values={values}
      dropdownRender={modalContext !== undefined && isFunction(dropdownRender) ? dropdownRender(modalContext.setFormHandler) : undefined}
      onChange={onChange}
      empty={empty}
    />
  )
}

export default SchoolsSelector
